import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('cg-typing-indicator')
export class CGTypingIndicator extends LitElement {
  static override styles = css`
    :host {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      height: 16px;
    }

    .dot {
      width: 5px;
      height: 5px;
      border-radius: 999px;
      background: var(--cg-muted);
      animation: blink 1.4s infinite both;
    }

    .dot:nth-child(2) { animation-delay: 0.2s; }
    .dot:nth-child(3) { animation-delay: 0.4s; }

    @keyframes blink {
      0% { opacity: 0.25; }
      20% { opacity: 1; }
      100% { opacity: 0.25; }
    }
  `;

  override render() {
    return html`
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    `;
  }
}
